import {
  ChangeDetectorRef,
  Component,
  inject,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';
import { ClientService } from '../../services/client.service';
import { MatPaginator } from '@angular/material/paginator';
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table';
import { Client, CLIENT_COLUMN_FORMATTED } from '../../model/client';
import { map, startWith, switchMap } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSortModule, Sort } from '@angular/material/sort';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { initPopupData } from '../../model/popup-data';
import { FdTablePaginationDirective } from '../../directives/fd-table-pagination/fd-table-pagination.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { GlobalVariables } from '../../constants/global-constants';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ColumnSearch, ColumnSearchDetails } from '../../model/bulk-operations';
import { TableNoDataComponent } from '../table-no-data/table-no-data.component';
import { HeaderComponent } from '../header/header.component';
import { ProfileMenuComponent } from '../profile-menu/profile-menu.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { WelcomeSplashComponent } from '../home/welcome-splash/welcome-splash.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AcquireOnboardingWizardService } from '../../services/acquire-onboarding-wizard/acquire-onboarding-wizard.service';
import { MultipleMerchantsDialogComponent } from '../acquire-onboarding-wizard/multiple-merchants-dialog/multiple-merchants-dialog.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MERCHANT_ID_QUERY_PARAM } from '../../model/client-onboarding/acquire-onboarding-wizard-stepper';

@Component({
  selector: 'app-select-client',
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginator,
    MatCheckboxModule,
    MatSelectModule,
    MatSortModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FdTablePaginationDirective,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    TableNoDataComponent,
    HeaderComponent,
    ProfileMenuComponent,
    LanguageSelectorComponent,
    MatToolbarModule,
    WelcomeSplashComponent,
    MultipleMerchantsDialogComponent,
    MatDialogModule,
  ],
  templateUrl: './select-client.component.html',
  styleUrl: './select-client.component.scss',
})
export class SelectClientComponent {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChildren(FdTablePaginationDirective) fdCustomTableDirective;

  data = new MatTableDataSource<Client>();
  columnSearches: ColumnSearch[] = [
    {
      columnName: '',
      columnValue: '',
    },
  ];
  columnSearchDetails: ColumnSearchDetails = {
    columnSearchQueryParams: '',
    columnSearches: this.columnSearches,
  };

  totalData: number = 0;
  pageSizes = GlobalVariables.PaginationSizes;
  pages: number[];
  currentPage: number = 1;

  isLoading: boolean = true;
  loadingData: boolean = false;

  displayedColumns = [
    'fdClientId',
    'companyName',
    'contactFirstName',
    'contactLastName',
    'status',
  ];
  displayedColumnsSearchInput = [
    'searchInput_fdClientId',
    'searchInput_companyName',
    'searchInput_contactFirstName',
    'searchInput_contactLastName',
    'searchInput_status',
  ];
  FormatColumns = CLIENT_COLUMN_FORMATTED;

  selection = new SelectionModel<Client>(true, []);
  ClientData;
  filter = new FormControl('');
  sorter: Sort = {
    active: 'fdClientId',
    direction: 'asc',
  };
  popupdata = initPopupData;
  scopesAction = [];
  path = '';
  onboardingId;
  dialog = inject(MatDialog);
  constructor(
    public utilities: UtilitiesService,
    private clientService: ClientService,
    private changeDetectorRefs: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private acquireOnboardingService: AcquireOnboardingWizardService,
  ) {
    this.utilities.isfullPage = true;
    this.utilities.clientId = 0;
  }

  ngOnInit() {
    const resolved = this.route.snapshot.data['clients'];
    if (resolved?.data) {
      return;
    }
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.data.paginator = this.paginator;
    }
    this.getClientDataPaging(false);
    this.utilities.showLogo = true;
  }

  getClientDataPaging(isRefreshPagination: boolean) {
    this.loadingData = true;
    this.paginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          return this.getTableData$();
        }),
        map((resData: any) => {
          if (resData == null) return [];
          if (resData.data.length === 1) {
            const client = resData.data[0];
            this.utilities.setIsUniqueClient(true);
            this.utilities.setIsPartner(client.isPartner);
            this.utilities.setCompanyName(client.companyName);
            this.utilities.clientId = client.fdClientId;
            this.selectClient(
              client.fdClientId,
              client.isPartner,
              client.companyName,
              client.active,
              client.onboardingId,
              client.status,
            );
          } else {
            this.utilities.setIsUniqueClient(false);
          }
          this.totalData = resData.meta.total;
          this.currentPage = this.paginator.pageIndex + 1;
          var totalPages = Math.ceil(this.totalData / this.paginator.pageSize);
          if (totalPages) {
            this.pages = [...Array(totalPages).keys()].map((page) => page + 1);
          }
          this.isLoading = false;
          return resData.data;
        }),
      )
      .subscribe({
        next: (res: any) => {
          this.ClientData = res;
          this.data = new MatTableDataSource(this.ClientData);
          this.changeDetectorRefs.detectChanges();
          if (isRefreshPagination) {
            this.fdCustomTableDirective.first.refreshPagination();
          }
          isRefreshPagination = false;
          this.isLoading = false;
        },
        error: (err: any) => {
          this.isLoading = false;
          this.popupdata.title = 'Failed';
          this.popupdata.content = err.error.message;
          this.popupdata.warn = true;
          this.openDialog();
        },
      });
  }

  openDialog(): void {
    var data = {
      ...this.popupdata,
      content: this.popupdata.content,
    };
    this.utilities.showSnackbarAlert(data);
  }

  getTableData$() {
    return this.clientService.fetchAll(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      this.sorter.active,
      this.sorter.direction,
      this.columnSearchDetails.columnSearchQueryParams,
    );
  }

  jumpToPage(page: number) {
    this.paginator.pageIndex = page - 1;
    this.paginator['_emitPageEvent'](page);
  }

  sortData(sort: Sort) {
    this.sorter = sort;
    this.getClientDataPaging(false);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.data.data);
  }

  selectClient(
    fdClientId,
    isPartner,
    companyName,
    active,
    onboardingId,
    status,
    acquirerOnboardingId?,
  ) {
    this.utilities.clientId = fdClientId;
    this.utilities.setIsPartner(isPartner);
    this.utilities.setCompanyName(companyName);
    this.utilities.isSelectClientRoute.set(false);
    this.onboardingId = onboardingId;
    this.utilities.setMerchantOnboardingId(null);

    if (localStorage.getItem('wooCommerceSession') === 'true') {
      this.utilities.redirectToContractAcknowledgment(fdClientId);
      return;
    }

    if (localStorage.getItem('wooCommerceSession') === 'true') {
      this.utilities.redirectToContractAcknowledgment(fdClientId);
      return;
    }

    if (active === 5) {
      if (acquirerOnboardingId) {
        localStorage.setItem('onboardingId', String(acquirerOnboardingId));
        this.acquireOnboardingService
          .getMerchants(acquirerOnboardingId)
          .subscribe({
            next: (merchants) => {
              if (merchants.length > 1) {
                this.dialog.open(MultipleMerchantsDialogComponent, {
                  data: {
                    acquirerOnboardingId: acquirerOnboardingId,
                    merchants: merchants,
                  },
                });
              } else if (merchants.length === 1) {
                this.utilities.setMerchantOnboardingId(Number(merchants[0].id));
                this.router.navigate(
                  [
                    'acquire-onboarding',
                    this.utilities.clientId,
                    acquirerOnboardingId,
                  ],
                  {
                    queryParams: { [MERCHANT_ID_QUERY_PARAM]: merchants[0].id },
                    queryParamsHandling: 'merge',
                  },
                );
              } else {
                this.router.navigate([
                  'acquire-onboarding',
                  this.utilities.clientId,
                  acquirerOnboardingId,
                ]);
              }
            },
            error: (err) =>
              console.error('Could not resolve acquirer onboarding ID', err),
          });
        //this.router.navigate(['acquire-onboarding', this.utilities.clientId, acquirerOnboardingId]);
      } /* else {
        this.acquireOnboardingService.fetchAcquirerOnboarding(fdClientId).subscribe({
          next: (res) => {
            const aoId = res?.result?.id;
            if (aoId) {
              localStorage.setItem('onboardingId', String(aoId));
              this.router.navigate(['acquire-onboarding', this.utilities.clientId, aoId]);
            }
          },
          error: (err) => console.error('Could not resolve acquirer onboarding ID', err)
        });
      } */
    } else if (active === 4 || status === 'Onboarding') {
      if (
        this.utilities.isFdUserValue ||
        this.utilities.isPartnerOnboardingUser ||
        this.utilities.roleValue === 'demo_client_admin_w_onboarding_wizard'
      ) {
        localStorage.setItem('onboardingId', String(this.onboardingId));
        this.router.navigate([
          'client-onboarding',
          this.utilities.clientId,
          this.onboardingId,
        ]);
        return;
      }
      this.router.navigate(['/onboarding-in-process'], {
        queryParams: { clientId: this.utilities.clientId },
      });
    } else {
      this.utilities.redirectToDefaultURL();
    }
  }

  onFinishSplash() {
    this.utilities.hideOnboardingSplash();
    const isFdUser = this.utilities.isFdUserValue;
    if (isFdUser || this.utilities.isPartnerOnboardingUser) {
      this.router.navigate([
        'client-onboarding',
        this.utilities.clientId,
        this.onboardingId,
      ]);
      return;
    }
  }

  searchByColumn(event, columnName, isEnter) {
    let columnValue = event.target.value;

    this.columnSearchDetails = this.utilities.getColumnSearchParams(
      columnName,
      columnValue,
      this.columnSearchDetails.columnSearches,
    );
    if (isEnter) {
      this.getClientDataPaging(true);
    }
  }

  getStatusChipClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'onboarding':
        return 'chip-onboarding';
      case 'active':
        return 'chip-active';
      case 'internal use':
        return 'chip-internal';
      case 'dormant':
        return 'chip-dormant';
      case 'acquirer onboarding':
        return 'chip-acquirer-onboarding';
      default:
        return 'chip-unknown';
    }
  }
}
